import { REQUEST } from 'utils/actionGenerator';
import { takeLatest } from 'redux-saga/effects';
import * as api from './api';

import { fetchEntitySpawn } from 'store/saga';
import * as activityTabActions from './actions';

export function* getCommentsList(params) {
  const request = api.getCommentsRequest(params);
  yield fetchEntitySpawn(request, activityTabActions.getCommentsList, params);
}

export function* getSubStageDetails(params) {
  const request = api.getSubStageDetailsRequest(params);
  yield fetchEntitySpawn(request, activityTabActions.getSubStageDetails, params);
}

export function* submitSubStageDetails(payload) {
  const request = api.postSubStageDetailsRequest(payload.payload);
  yield fetchEntitySpawn(request, activityTabActions.submitSubStageDetails, {
    toaster: { successMsg: 'Sub Status updated successfully', errorMsg: '' },
    payload,
  });
}

export function* getAuditList(params) {
  const request = api.getAuditRequest(params);
  yield fetchEntitySpawn(request, activityTabActions.getAuditList, params);
}

export function* postComment(payload) {
  const request = api.postCommentRequest(payload.payload);
  yield fetchEntitySpawn(request, activityTabActions.postComment, {
    toaster: { successMsg: 'Comment posted successfully', errorMsg: '' },
    payload,
  });
}

function* mySaga() {
  yield takeLatest(activityTabActions.GET_COMMENTS_LIST[REQUEST], getCommentsList);
  yield takeLatest(activityTabActions.GET_SUB_STAGE_DETAILS[REQUEST], getSubStageDetails);
  yield takeLatest(activityTabActions.POST_SUB_STAGE_DETAILS[REQUEST], submitSubStageDetails);
  yield takeLatest(activityTabActions.GET_AUDIT_LIST[REQUEST], getAuditList);
  yield takeLatest(activityTabActions.POST_COMMENT[REQUEST], postComment);
}

export default mySaga;
